"use client";

import { useIsMounted } from "@/hooks/use-is-mounted";
import CarbonLayout from "@/layouts/carbon/carbon-layout";
import { ReactNode } from "react";

type LayoutProps = {
  children?: ReactNode | JSX.Element | null;
};

export default function DefaultLayout({ children }: LayoutProps) {
  return <LayoutProvider>{children}</LayoutProvider>;
}

function LayoutProvider({ children }: LayoutProps) {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  return <CarbonLayout>{children}</CarbonLayout>;
}
